import React, {Component} from 'react'
import { Videos } from './..'

export default class VideoTemplate extends Component {
  render() {
    return (
      <div className={`product-template product-template--videos`}>
        <div className="template-scroll">
          <Videos {...this.props} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/VideoTemplate.js